import SubmissionError from '../../../../error/SubmissionError'
import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const create = ({ commit }, values) => {
  commit(types.INCOTERM_CREATE_SET_ERROR, '')
  commit(types.INCOTERM_CREATE_TOGGLE_LOADING)

  return fetch('/incoterms', { method: 'POST', body: JSON.stringify(values) })
    .then((response) => {
      commit(types.INCOTERM_CREATE_TOGGLE_LOADING)

      return response.json()
    })
    .then((data) => {
      commit(types.INCOTERM_CREATE_SET_CREATED, data)

      return data
    })
    .catch((e) => {
      commit(types.INCOTERM_CREATE_TOGGLE_LOADING)

      if (e instanceof SubmissionError) {
        commit(types.INCOTERM_CREATE_SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        commit(types.INCOTERM_CREATE_SET_ERROR, e.errors._error)
        return
      }

      commit(types.INCOTERM_CREATE_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.INCOTERM_CREATE_RESET)
}



// WEBPACK FOOTER //
// ./src/store/modules/incoterm/create/actions.js